import { Notification } from '../../../../../models/Notification'
import { StylesScene } from '../../../../../models/Story'
import { getNotificationImgPathes } from '../../resolveImgPath'

type TUserDoneTaskStyles = {
    [key: string]: StylesScene
}

const UserDoneTaskStyles: TUserDoneTaskStyles = {
    'Group': {
        mainImg: {
            container: {
                width: 372,
                height: 223,
                border: '8px solid #fff',
                borderRadius: 4,
                position: 'absolute',
                bottom: 162,
                left: 65,
                zIndex: 2,
            }
        },
        completedChecklistOption: {
            container: {
                position: 'absolute',
                top: 400,
                left: 89,
                zIndex: 3,
                borderRadius: 6,
                background: 'rgba(0, 0, 0, .9)',
                padding: '3px 18px',
                maxHeight: 125,
                width: 324,
                boxSizing: 'border-box',
            },
            text: {
                fontWeight: 'bold',
                color: '#fff',
                lineHeight: 1.3,
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.35)',
                letterSpacing: 0,
                textAlign: 'center',
                fontSize: 25
            }
        },
        dataTypeTag: {
            container: {
                position: 'absolute',
                top: 153,
                right: 77,
            },
            text: {
                opacity: 0.8,
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 24,
                fontWeight: 800,
                lineHeight: 2.33,
                letterSpacing: 0.5,
                color: '#ffd288',
            }
        },
        dataTypeTitle: {
            container: {
                position: 'absolute',
                top: 184,
                right: 16
            },
            text: {
                opacity: 0.75,
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 20,
                fontWeight: 800,
                lineHeight: 2.8,
                letterSpacing: 0.5,
                color: '#fff',
                textTransform: 'uppercase'
            }
        },
        groupTitleCollection: {
            container: {
                position: 'absolute',
                top: 242,
                right: 15,
                background: '#fff',
                padding: '10px 16px 12px',
                borderRadius: 4,
                zIndex: 2,
            },
            text: {
                fontFamily: 'Roboto Slab',
                fontSize: 20,
                fontWeight: 'bold',
                color: '#000',
            }
        },
        groupImg: {
            container: {
                position: 'absolute',
                zIndex: 1,
                top: 269,
                left: 74,
                boxSizig: 'border-box',
                width: 356,
                height: 210
            }
        },
        workInProgressImg: {
            container: {
                left: 21,
                top: 204,
                position: 'absolute',
                zIndex: 3,
                width: 148,
                height: 118
            }
        },
        docTitle: {
            container: {
                position: 'absolute',
                bottom: 65,
                right: 224,
                padding: '6px',
                borderRadius: 4,
                zIndex: 2,
                backgroundColor: '#fff',
                maxHeight: 125,
                maxWidth: 240
            },
            text: {
                fontFamily: 'Rubik',
                fontSize: 18,
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.5,
                letterSpacing: 0,
                textAlign: 'center',
                color: '#0e0e14',
            }
        }
    },
    'Public': {
        completedChecklistOption: {
            container: {
                position: 'absolute',
                top: 520,
                left: '53%',
                transform: 'translateX(-50%)',
                padding: '5px 25px',
                borderRadius: 4,
                zIndex: 2,
                backgroundColor: '#000',
                maxHeight: 125,
                width: 324,
                boxSizing: 'border-box',
            },
            text: {
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.5,
                letterSpacing: 0,
                textAlign: 'center',
                color: '#fff',
                fontSize: 25
            }
        },
        mainImg: {
            container: {
                width: 400,
                height: 254,
                border: '8px solid #fff',
                borderRadius: 6,
                position: 'absolute',
                top: 290,
                left: 20,
            }
        },
        taskDoneCheck: {
            container: {
                width: 85,
                height: 85,
                position: 'absolute',
                zIndex: 10,
                top: 478,
                left: 31,
                transform: 'rotate(-17deg)',
            }
        },
        dataTypeTag: {
            container: {
                position: 'absolute',
                top: 639,
                left: 100,
                width: 300
            },
            text: {
                fontFamily: 'Roboto Slab',
                textShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
                fontSize: 36,
                fontWeight: 800,
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.56,
                letterSpacing: 0,
                color: '#ffd288',
            }
        },
        dataTypeTitle: {
            container: {
                bottom: 207,
                left: 20,
                position: 'absolute',
                width: 300
            },
            text: {
                fontFamily: 'Roboto Slab',
                textShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
                textTransform: 'uppercase',
                fontSize: 36,
                fornWeight: 600,
                color: '#fff',
                lineHeight: 1.56,
            }
        },
        docTitle: {
            container: {
                position: 'absolute',
                bottom: 75,
                right: 224,
                padding: '6px',
                borderRadius: 4,
                zIndex: 2,
                backgroundColor: '#fff',
                maxHeight: 125,
                maxWidth: 240
            },
            text: {
                fontFamily: 'Rubik',
                fontSize: 18,
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.5,
                letterSpacing: 0,
                textAlign: 'center',
                color: '#0e0e14',
            }
        }
    }
}

export const getUserDoneTaskBackground = (notif: Notification): [string, StylesScene] => {
    return [getNotificationImgPathes(notif.systemActionTypeUid)[notif.groupType], UserDoneTaskStyles[notif.groupType]]}